import { jsxs as h, jsx as r } from "react/jsx-runtime";
import { useState as w, useRef as T, useEffect as b } from "react";
import n from "./styles.module.less.js";
import v from "../chevron-down.svg.js";
import { GradientButton as k } from "../gradient-button/index.js";
const R = (m) => {
  const {
    children: l,
    classNames: e,
    label: o,
    icon: f,
    path: c,
    isActive: p,
    hasShrunk: d,
    onClick: u,
    chevronStyle: t,
    customHover: C,
    useGradient: I
  } = m, S = c ? "a" : "div", [g, $] = w(!1), i = T(null);
  return b(() => {
    const a = () => {
      $(!0), i.current && clearTimeout(i.current), i.current = setTimeout(() => {
        $(!1);
      }, 100);
    };
    return window.addEventListener("scroll", a), () => {
      window.removeEventListener("scroll", a);
    };
  }, []), /* @__PURE__ */ h(
    "div",
    {
      className: `${n.menuItemWrapper} ${g ? n.scrolling : ""} ${C ? n.noHover : ""} ${e == null ? void 0 : e.wrapper}`,
      children: [
        /* @__PURE__ */ r(
          "div",
          {
            className: `${n.menuItemContainer} ${e == null ? void 0 : e.labelContainer}`,
            children: I ? /* @__PURE__ */ r(
              k,
              {
                label: o,
                isScrolledHeader: d,
                onClick: u,
                className: `${n.gradientButton} ${(e == null ? void 0 : e.gradientButton) ?? ""}`,
                children: t && /* @__PURE__ */ r(
                  v,
                  {
                    className: `${n.chevronIcon} ${(e == null ? void 0 : e.chevronIcon) ?? ""} ${t === "no-rotate" ? n.noRotate : ""}`
                  }
                )
              }
            ) : /* @__PURE__ */ h(
              S,
              {
                href: c,
                className: `${n.labelContainer} ${(e == null ? void 0 : e.linkContainer) ?? ""} ${p ? n.active : ""} ${d ? n.shrunk : ""}`,
                onClick: u,
                children: [
                  f,
                  /* @__PURE__ */ r(
                    "span",
                    {
                      className: `${n.labelTitle} ${e == null ? void 0 : e.labelTitle}`,
                      title: o,
                      children: o
                    }
                  ),
                  t && /* @__PURE__ */ r(
                    v,
                    {
                      className: `${n.chevronIcon} ${e == null ? void 0 : e.chevronIcon} ${t === "no-rotate" ? n.noRotate : ""}`
                    }
                  )
                ]
              }
            )
          }
        ),
        l ? /* @__PURE__ */ r(
          "div",
          {
            className: `${n.childContainer} ${e == null ? void 0 : e.childContainer}`,
            children: l
          }
        ) : null
      ]
    }
  );
};
export {
  R as MenuItem
};
